import React, { useEffect, useState } from 'react';
import { view } from '@forge/bridge';
import { FullContext } from '@forge/bridge/out/types';

import Configuration from './config';

export const JiraexpEntryPoint = () => {
    const [entryPoint, setEntryPoint] = useState();

    useEffect(() => {
        void view.getContext().then((context: FullContext) => setEntryPoint(context.extension.entryPoint || 'view'));
    }, []);

    return entryPoint ?
            <>
                {entryPoint === 'contextConfig' ?
                    <Configuration/>
                    : <div>edit</div>}
            </>
        :   null;
};
